import React from "react";

const BulletCard = ({ item }) => {
  return (
    <div className="card group flex items-center justify-between gap-4 p-4 rounded-2xl shadow-lg bg-white w-full max-w-xl">
      {/* Left section with icon and text */}
      <div className="flex items-center gap-4 flex-1">
        {item.icon && (
          <div className="flex h-10 w-10 flex-none items-center justify-center">
            <item.icon
              className="h-6 w-6 text-gray-600 group-hover:text-purple-700"
              aria-hidden="true"
            />
          </div>
        )}
        <div className="text-left">
          <p className="font-bold text-base text-purple-700">{item.label}</p>
          <p className="text-sm text-gray-600">{item.description}</p>
        </div>
      </div>

      {/* Right-aligned image */}
      {item.img && (
        <img
          src={item.img}
          alt={item.label}
          className="h-12 w-12 object-contain flex-none"
        />
      )}
    </div>
  );
};

export default BulletCard;
